import './index.css'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import { Amplify } from 'aws-amplify'
import awsConfig from './aws-exports'

import App from './pages/App'
import { rootReducer, rootSaga } from './redux'
import createStore from './redux/store'
import reportWebVitals from './reportWebVitals'

Amplify.configure(awsConfig)

const { store, persistor } = createStore({
  rootReducer,
  rootSaga
})

render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()
